import about from '../img/about/cakeC.png';

const About = () => {
  return (
    <section id="about" className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto flex flex-col">
        <div className="lg:w-4/6 mx-auto">
          <div className="text-center mb-20">
            <h1
              className="
                title-font
                sm:text-5xl
                text-5xl mb-4
                font-medium
              "
            >
              Little Bit About Us
            </h1>
            <div className="flex mt-6 justify-center">
              <div
                className="
                  w-28
                  h-2
                  rounded-full
                  bg-purple-500
                  inline-flex
                "
              ></div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row mt-10">
            <div className="sm:w-1/3 text-center sm:pr-8 sm:py-8">
              <div
                className="
                  w-full
                  h-full
                  rounded-full
                  inline-flex
                  items-center
                  justify-center
                  text-gray-600
                "
              >
                <img src={about} alt="about" />
              </div>
            </div>
            <div
              className="
                sm:w-2/3
                sm:pl-8
                sm:py-8
                sm:border-l
                border-gray-300
                sm:border-t-0
                border-t
                mt-4
                pt-4
                sm:mt-0
                text-center
                sm:text-left
              "
            >
              <p className="leading-relaxed text-lg mb-4 sm:mt-8 mt-0">
                Slice of Dreams, is an online Cake Shop. We pride with
                delivering the cakes and jar cakes to you! All of our cakes are
                made fresh from scratch with every order.I'm a baker because
                I've dreamed of becoming a sugar connoisseur my entire life.
              </p>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.facebook.com/Sliceofdream"
                className="text-purple-500 inline-flex items-center"
              >
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
